import { asyncLoadScript } from "integrations/helpers";
import { catchErrors, skipForDevelopment, skipForPrerender } from "shared/mechanics/decorators";
import { Logger } from "shared/mechanics/logging";
import { IPlugin } from "shared/mechanics/plugin";

declare const Ya: any;

declare global {
	interface Window { yandexContextAsyncCallbacks: any[]; }
}

export interface IYandexAdsPlugin extends IPlugin {
	render(blockId: string, containerElementId: string, notRenderCallback: () => void): void
}

export class YandexAdsPlugin implements IYandexAdsPlugin {
	name: string = 'Yandex Ads';

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	init(): void {
		asyncLoadScript('https://site.yandex.net/v2.0/js/all.js');
		asyncLoadScript('https://an.yandex.ru/system/context.js');

		window.yandexContextAsyncCallbacks = [];
	}

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	render(blockId: string, containerElementId: string, notRenderCallback: () => void): void {
		window.yandexContextAsyncCallbacks.push(function() {
			Ya.Context.AdvManager.render({
				blockId: blockId,
				renderTo: containerElementId,
				async: true
			}, function () {
				notRenderCallback();
			});
		});
	}
}